/* eslint-disable react/prop-types */
import { FC } from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import styles from './table.module.scss';

export interface Beneficiary {
  name?: string;
  nominationType?: string;
  percentage?: number;
  relationship?: string;
}

export interface Props {
  tableData: Beneficiary[] | undefined;
}

const ListedBeneficiaries = ({ tableData }: Props): JSX.Element => {
  const TableRows: FC = () => {
    if (tableData?.length) {
      return (
        <TableBody>
          {tableData.map((_item, index) => {
            const reactKey = `${index}index`;
            return (
              <TableRow key={reactKey}>
                <TableCell>
                  <Typography data-testid={`name${index}`} className={styles.rowData}>
                    {_item?.name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography data-testid={`relationship${index}`} className={styles.rowData}>
                    {_item?.relationship}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography data-testid={`nominationType${index}`} className={styles.rowData}>
                    {_item?.nominationType}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography data-testid={`percentage${index}`} className={styles.rowData}>
                    {/* {percentageFormatter(_item?.percentage || 0)} */}
                    {_item?.percentage || 0}%
                  </Typography>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      );
    }
    return <></>;
  };
  return (
    <TableContainer component={Paper} elevation={0}>
      <Table>
        <TableHead>
          <TableRow className={styles.tableHeader}>
            <TableCell>
              <Typography data-testid="header1">Name</Typography>
            </TableCell>
            <TableCell>
              <Typography data-testid="header2">Relationship</Typography>
            </TableCell>
            <TableCell>
              <Typography data-testid="header3">Type</Typography>
            </TableCell>
            <TableCell align="right">
              <Typography data-testid="header4">Percentage</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableRows />
      </Table>
    </TableContainer>
  );
};

export default ListedBeneficiaries;
